export const b64toBlob = (base64) => 
  fetch(base64, {
    mode: 'no-cors',
  }).then(res => res.blob())
    .catch(() => {})